import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";

import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBRow,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBTextArea
} from "mdb-react-ui-kit";

import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import { useLocation } from "react-router";
import { useForm } from "react-hook-form";
import StreamTeamGeneralSettings from "../components/editviews/user/StreamTeamGeneralSettings";
import SaveChanges from "../components/topviews/saveCancel";
import TopSuccess from "../components/header/TopSuccess";
import TopMessage from "../components/header/TopMessage";
import { UpdateStreamTeam, getTeamsDetails } from "../apiclients/streamsapi_bridge";
import UseranTeamAdmin from "../components/editviews/user/UseranTeamAdmin";
import { defaultUImg } from "../components/images";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import { getStreamsProductName } from "../apiclients/CommonUtils";

function SelectedTeamSettings(props) {

  const location = useLocation();
  const [teamInfo, setTeamInfo] = useState(
    location?.state?.teamInfo ? location.state.teamInfo : location?.state ? location.state : {}
  );
  const actTab = location.state ? location.state.tab ? location.state.tab : "tab1" : "tab1";
  // const reloadTeamid = location.state ? location.state.teamids ? location.state.teamids : "" : "";
  const [basicActive, setBasicActive] = useState(actTab);
  const [successMessage, setSuccessMessage] = useState("");
  const [isloading, setIsLoading] = useState(false);
  const { setEdited } = useAdminContext();
  const [internalError, setInternalError] = useState(false);
  const [internalErrorMessage, setInternalErrorMessage] = useState("");
  const streamsProductName = getStreamsProductName();

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const [verticalActive, setVerticalActive] = useState("tab1");

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [rerender, setReRender] = useState(false);
  const [teamName, setteamName] = useState("");
  const [teamType, setteamType] = useState("");



  const { register, handleSubmit, formState: { errors, isDirty, dirtyFields }, setValue, getValues, clearErrors, watch, reset, setError } = useForm({
    defaultValues: {
      team_name: "",
      team_type: 3,
      accessibility: 2,
      enable_contributor: false,
      hide_team_members: false,
      description: "",

    }
  })

  useEffect(() => {
    if (teamInfo.team_id !== "" || rerender) {
      getTeamDetails();
      setReRender(false);
    }

  }, [teamInfo.team_id, rerender]);

  async function getTeamDetails() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      //alert(nineOOLoc.loc_id);
      setIsLoading(true);
      const serverResponsedata = await getTeamsDetails(siteid, teamInfo.team_id);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      if (!serverResponsedata.ok) {
        console.log("Network response was not ok");
        throw new Error('Network response was not ok');
      }
      else {
        const data = await serverResponsedata.json();
        if (data.status == "success") {
          console.log("data ::::: " + JSON.stringify(data));
            setteamType(data?.team_general_details?.team_type && parseInt(data?.team_general_details?.team_type) === 4 ? "Public" : "Company");
            setteamName(data?.team_general_details?.team_name ?? "");
          let resetData = {
            team_name: data?.team_general_details?.team_name ?? "",
            team_type: data?.team_general_details?.team_type ? parseInt(data?.team_general_details?.team_type) : 3,
            accessibility: data?.team_general_details?.accessibility ? parseInt(data?.team_general_details?.accessibility) : 2,
            enable_contributor: data?.team_general_details?.enable_contributor ?? false,
            hide_team_members: data?.team_general_details?.hide_team_members ?? false,
            description: data?.team_general_details?.description ?? "",

          }
          reset(resetData);
        }
      }
    } catch (error) {
      console.error("[get911SpecificLocation] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  function closeSave(e) {
    //navigate("/userlanding");
    reset();
  }

  const isdirtyFields =
    Object.keys(dirtyFields).length === 0 ? false : true;

  const onsubmit = async (data) => {
    setInternalError(false);
    setInternalErrorMessage("");
    const modifiedData = {};
    for (const field of Object.keys(dirtyFields)) {
      // Check if the field is dirty and exists in the data object
      if (dirtyFields[field] && data.hasOwnProperty(field)) {
        modifiedData[field] = data[field];
      }
    }
    if (modifiedData) {
      modifiedData.reqid = 87;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.teamid = teamInfo.team_id;

      console.log("JSON Create Streams team:: " + JSON.stringify(modifiedData));
      setIsLoading(true);
      let saverep = await UpdateStreamTeam(modifiedData);
      console.log(`reponse of add Streams team: :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(`reponse of add Streams team: after:::: ${JSON.stringify(saverepeMsg)}`);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setReRender(true);
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();

            }
          });
        } else {
          setReRender(true);
          setInternalError(true);
          setInternalErrorMessage(saverepeMsg.message);
        }

      }
    }
  }

  useEffect(() => {
    setEdited(isdirtyFields);
  }, [isdirtyFields])





  return (
    <React.Fragment >
      <>
        <MainLinks active={3} />
        <Body
          tablinks={3}
          sublink={15}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a href="/userlanding">
                            <strong>{t("users")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="/streamsteamssection">
                            <strong>{t("StreamsTeams", {"PRODUCT_NAME" : streamsProductName})}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a href="#">
                            <strong>{teamName}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">


                    <div className="d-flex align-items-center">
                      <div>
                        <div className="user-profilePicture">
                          {/* <div className="profile-mask">
                            <MDBIcon
                              far
                              icon="edit"
                              color="white"
                              className="fs-5 EditProfile cursor-pointer"
                            />
                            <MDBIcon
                              className="ms-4 fs-5"
                              fas
                              icon="times"
                              color="white RemoveProfile cursor-pointer"
                            />
                          </div> */}
                          <img
                            src={defaultUImg}
                            // src='https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="userName">
                          {/* <h5 className="fw-600 mt-2 mb-2 pb-0 ">New Team</h5> */}
                          <h5 className="fw-600 mt-2 mb-2 pb-0 ">{teamName}</h5>
                          <p className="m-0 mb-2">
                            {teamType}
                          </p>
                          <p title="Description">
                            {watch("description")}
                            {/* Hello this is streams team */}
                          </p>
                        </div>

                      </div>
                    </div>


                    {/* <div className="row pb-0 pt-1">
                      <div className="w-20 pos-relative text-center profile_pic">
                        <div className="">
                          <img
                            src="https://mdbootstrap.com/img/new/avatars/7.jpg"
                            alt=""
                            className="p-3 pb-0 w-100 rounded-circle profile_pic"
                          />
                        </div>
                        <div className="position-relative bottom-10">
                          <MDBIcon
                            far
                            icon="edit"
                            className="btn-circle edit-icon profile_edit"
                          />
                          <MDBIcon
                            fas
                            icon="times"
                            className="btn-circle remove-icon profile_cancel"
                          />
                        </div>
                      </div>
                      <div className="w-80">
                        <h5 className="fw-600 mt-2">{t("TelephonyTeam")}</h5>
                        <p className=" my-2 text-secondary">{t("Private")}</p>
                        <p className="  text-secondary">{t("Privatetxt")}</p>
                      </div>
                    </div> */}

                    <MDBTabs className="mt-4 mb-2">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          {t("UsersTeamAdmins")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        {/* Tab 1 content */}
                        <MDBRow>
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <MDBTabs className="flex-column text-center">
                              <MDBTabsItem>
                                <MDBTabsLink
                                  onClick={() => handleVerticalClick("tab1")}
                                  active={verticalActive === "tab1"}
                                >
                                  {t("general")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                            </MDBTabs>
                          </MDBCol>
                          <MDBCol
                            size="12"
                            md="10"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <MDBTabsContent>
                              <MDBTabsPane open={verticalActive === "tab1"}>
                                <StreamTeamGeneralSettings
                                  register={register}
                                  errors={errors}
                                  watch={watch}
                                  setValue={setValue}
                                />
                                {isdirtyFields && (
                                  <SaveChanges
                                    onClose={closeSave}
                                    isdirtyFields={isdirtyFields}
                                    onSave={(e) => {
                                      e.preventDefault();
                                      handleSubmit(onsubmit)();
                                    }}
                                  />
                                )}
                              </MDBTabsPane>
                            </MDBTabsContent>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>
                      <MDBTabsPane open={basicActive === "tab2"}>
                        {/* Tab 2 content */}
                        <UseranTeamAdmin
                          isActive={basicActive === "tab2"}
                          // teamid = {teamInfo.team_id ?? reloadTeamid}
                          teamInfo={teamInfo}
                          setSuccessMessage={setSuccessMessage}
                          setEdited={setEdited}
                          teamType={teamType}
                        />


                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>

                </div>
              </section>
            </>
          }
        />
        {/* <Footer /> */}
        <Tooltip anchorSelect=".EditProfile" place="top" className="exampleTooltip">
          Edit Profile
        </Tooltip>
        <Tooltip anchorSelect=".RemoveProfile" place="top" className="exampleTooltip">
          Remove Profile
        </Tooltip>
        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Delete
        </Tooltip>
        {successMessage && (
          <>
            <TopSuccess>
              <TopMessage successMessage={successMessage} />
            </TopSuccess>
          </>
        )}
        {isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}
        {internalError && (
          <MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={5000}
            onClose={() => setInternalError(false)}
          >
            {internalErrorMessage}
          </MDBAlert>
        )}
      </>
    </React.Fragment >
  );
}

export default SelectedTeamSettings;
